module.exports = __webpack_public_path__ + "static/cases-tile-3-1-db3e6ed2c2d4f1af43c9b6273c5b50b8.png";